module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.11598c28.ttf";